<template>
  <div class="school" :style="bannerFlag ? 'margin-top: 45px;':''">

    <div class="container w">

      <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)"
        style="min-height: calc(100vh - 125px);">

        <div class="school-item" v-if="newsList.length > 0" style="min-height: calc(100vh - 130px);">

          <div class="school-box">
            <school-item v-for="(item,i) in newsList" :key="i" :msg="item"></school-item>
          </div>

          <div class="fill-full"></div>

          <div class="pagination-wrap w" v-if="newsList.length > 0 && !error">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum"
              :page-size="queryParams.pageSize" layout="total,prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>

        </div>

        <div class="no-info" v-if="noNews">
          <div class="no-data">
            <img src="/static/images/no-search.png">
            <br> 抱歉！暂时还没有资讯
          </div>
        </div>

        <div class="no-info" v-if="error">
          <div class="no-data">
            <img src="/static/images/error.png">
            <br> 抱歉！出错了...
          </div>
        </div>

      </div>
    </div>
    <Customer class="customerSer"></Customer>
  </div>
</template>
<script>
  import {
    mapMutations,
    mapState
  } from 'vuex';
  import schoolList from "/assets/config/schoolList.js";
  import schoolItem from '/components/schoolItem'
  import Customer from '../Order/components/customerSer'
  export default {
    data() {
      return {
        bannerFlag: false,
        loading: true,
        error: false,
        noNews: false,
        newsList: [],
        queryParams: {
          pageNum: 1,
          pageSize: 15,
        },
      }
    },
    computed: {
      ...mapState(['user'])
    },
    methods: {
      // 控制顶部
      navFixed() {
        if (this.$route.path === '/news') {
          var st = document.documentElement.scrollTop || document.body.scrollTop
          st >= 60 ? this.bannerFlag = true : this.bannerFlag = false
        } else {
          return
        }
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.loadNewsData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.loadNewsData()
      },
      loadNewsData() {
        this.loading = true

        setTimeout(() => {
          this.newsList = schoolList
          this.noNews = this.newsList.length > 0 ? false : true
          this.total = this.newsList.length
          this.loading = false
        }, 600);

      }
    },
    created() {
      // if(this.user.userType === '99'){
      //   this.$store.commit('common/recordNav',{navIndex: 2,navSubIndex: 0})
      // }else{
      //   this.$store.commit('common/recordNav',{navIndex: 3,navSubIndex: 0})
      // }
      this.loadNewsData();
    },
    mounted() {
      this.navFixed()
      window.addEventListener('scroll', this.navFixed)
      window.addEventListener('resize', this.navFixed)
      document.title = "医小智 - 齿科学院"
    },
    components: {
      schoolItem,
      Customer
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../../assets/style/mixin";
  @import "../../assets/style/theme";

  .school {}

  .container {
    margin: 10px auto;
    display: flex;
    flex-direction: column;
  }

  .school-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;
  }

  .school-box {
    // >div {
    //   float: left;
    //   border: 1px solid #efefef;
    // }
    // border: 1px solid red;
  }

  .pagination-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // background: #fff;
    // border: 1px solid #efefef;
    // border-radius: 8px;
    transition: all .5s;
    padding: 10px 0;
  }

  .no-info {
    padding: 100px 0;
    text-align: center;
    font-size: 30px;
    display: flex;
    flex-direction: column;

    .no-data {
      align-self: center;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?a1a7f0e8